import { createStore } from "vuex";
import windrowRegistration from "./windrowRegistration";
import taxAdjustment from "./taxAdjustment";
import agendaAndMeeting from "./agendaAndMeeting";
import stormwater from "./stormwater";
import marina from "./marina";
import banquetInquiry from "./banquetInquiry";
import roadClosureAlert from "./roadClosureAlert";
import treePermit from "./treePermit";

import launchPermit from './launchPermit';
import onlineInquiry from './onlineInquiry';
// MODULE IMPORTS (DO NOT REMOVE)
export const store = createStore({
  modules: {
    launchPermit: {
      namespaced: true,
      ...launchPermit
    },
    onlineInquiry: {
      namespaced: true,
      ...onlineInquiry
    },
    // MODULE REGISTRATION (DO NOT REMOVE)
    windrowRegistration: {
      namespaced: true,
      ...windrowRegistration
    },
    taxAdjustment: {
      namespaced: true,
      ...taxAdjustment
    },
    agendaAndMeeting: {
      namespaced: true,
      ...agendaAndMeeting
    },
    stormwater: {
      namespaced: true,
      ...stormwater
    },
    marina: {
      namespaced: true,
      ...marina
    },
    banquetInquiry: {
      namespaced: true,
      ...banquetInquiry
    },
    roadClosureAlert: {
      namespaced: true,
      ...roadClosureAlert
    },
    treePermit: {
      namespaced: true,
      ...treePermit
    }
  }
});
